// src/pages/WhyCallistus.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import WhyUS_PageSection from './PageComponent/WhyUS_PageSection';


function WhyCallistus() {
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Why Callistus | Callistus Blinds</title>
        <meta
          name="description"
          content="Discover why Callistus stands out — the world's largest range of blinds, premium operating systems and a huge array of complementing fabrics."
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/why-callistus/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Why Callistus" />
        <meta
          property="og:description"
          content="Discover why Callistus stands out — the world's largest range of blinds, premium operating systems and a huge array of complementing fabrics."
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/why-callistus/`} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <div>
        <Navbar />
        <NotificationBar />
        <WhyUS_PageSection />
        <Footer />
      </div>
    </>
  );
}

export default WhyCallistus;